import * as React from "react"
import {
  TimeStampProps,
  HandleTouchStartType,
  HandleTouchEndType,
  UseTouchHandleReturn
} from "./types"

export const useTouchHandle = (): UseTouchHandleReturn => {
  const [timeStamp, setTimeStamp] = React.useState<TimeStampProps>({
    start: 0,
    end: 0
  })

  const handleTouchStart: HandleTouchStartType = event => {
    setTimeStamp({ ...timeStamp, start: event.timeStamp })
  }

  const handleOnTouchEnd: HandleTouchEndType = React.useCallback(
    (event, callback) => {
      if (event.timeStamp - timeStamp.start < 150) {
        callback(event)
      }
      setTimeStamp({ start: 0, end: 0 })
    },
    [timeStamp.start]
  )

  return {
    handleTouchStart,
    handleOnTouchEnd
  }
}
